
import React from 'react';

interface SolveTimeDisplayProps {
  solveTime: number;
}

export function SolveTimeDisplay({ solveTime }: SolveTimeDisplayProps) {
  // Format solve time for display
  const formatSolveTime = (time: number): string => {
    // Handle very small times (less than 1 second)
    if (time < 1000) return "1"; // Minimum display of 1 second

    // Normal case - round to whole seconds
    return Math.round(time / 1000).toString();
  };

  return (
    <div className="text-center text-sm text-gray-600 mt-2">
      Ranked in {formatSolveTime(solveTime)} seconds
    </div>
  );
}
